<div class="container-fluid dashboard-container">
    <!-- Bot Selection -->
    <!-- This will be done on the main reports integration and each bot is 
   icon is a link to the report bot component -->

    <!-- Date Filter and Download Button -->
    <div class="row mb-4">
        <mat-card class="h-100">
            <mat-card-content>
                <div class="col-12 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="filter-bar d-flex flex-wrap gap-3 align-items-center">
                        <button mat-stroked-button color="primary" (click)="openDateRangeDialog()"
                            aria-label="Open date range filter"
                            class="date-filter-btn d-flex justify-content-between align-items-center">
                            <span>Filter by Date</span>
                            <mat-icon class="calendar-icon">calendar_today</mat-icon>
                        </button>
                    </div>
                    <!-- <div class="download-button">
            <button mat-raised-button (click)="downloadReport()" aria-label="Download report">
              <mat-icon>download</mat-icon>
              Download Report
            </button>
          </div> -->
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row">
        <mat-tab-group class="tab-cards" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
            <mat-tab label="Demographics">
                <ng-template mat-tab-label>
                    <span class="mat-tab-label">Demographics</span>
                </ng-template>
                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.countryChartData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top">
                                        <mat-card-title class="custom-card-title card-title-with-tooltip">
                                            <span class="card-title-text">Learner Distribution by Country</span>
                                            <button
                                                type="button"
                                                class="what-is-this"
                                                matTooltipClass="dashboard-tooltip"
                                                [matTooltip]="tooltips.text('learnerDistributionByCountry')"
                                                aria-label="What is this? Learner Distribution by Country">
                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                What is this?
                                            </button>
                                        </mat-card-title>
                                        <mat-card-subtitle class="custom-country-subtitle">
                                            Most engaged learners by country
                                        </mat-card-subtitle>
                                    </div>

                                    <mat-divider class="header-divider"></mat-divider>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.countryChartData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Country"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.countryChartData.length > 0">
                                <app-africa-map
                                    [countryData]="baseService.countryIndexData">
                                </app-africa-map>
                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.countryIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.provinceIndexData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top-row">
                                        <div class="card-header-left">
                                            <mat-card-title class="custom-card-title card-title-with-tooltip">
                                                <span class="card-title-text">Learner Breakdown by Province</span>
                                                <button type="button" class="what-is-this"
                                                    matTooltipClass="dashboard-tooltip"
                                                    [matTooltip]="tooltips.text('learnerBreakdownByProvince')"
                                                    aria-label="What is this? Learner Breakdown by Province">
                                                    <mat-icon aria-hidden="true">info</mat-icon>
                                                    What is this?
                                                </button>
                                            </mat-card-title>
                                            <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                                        </div>
                                        <div class="card-header-right">
                                            <mat-form-field appearance="outline" class="header-filter under-header">
                                                <mat-label>Filter by Province</mat-label>
                                                <mat-select [(ngModel)]="baseService.selectedProvince"
                                                    (selectionChange)="onProvinceFilterChange()"
                                                    aria-label="Filter by province" multiple>
                                                    <mat-option [value]="null">All Provinces</mat-option>
                                                    <mat-option
                                                        *ngFor="let province of baseService.provinces; let i = index"
                                                        [value]="province.fullName">
                                                        <span class="color-dot"
                                                            [style.backgroundColor]="baseService.colorPalettes['province'][i % baseService.colorPalettes['province'].length]"></span>
                                                        {{ province.fullName }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <mat-divider class="header-divider"></mat-divider>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.provinceIndexData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Province Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.provinceIndexData.length > 0">
                                <!-- No data message -->
                                <div *ngIf="!baseService.provinceChartData && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No province data available</p>
                                </div>
                                <!-- Single Chart Canvas (only when data ready) -->
                                <div *ngIf="baseService.provinceChartData" class="chart-container">
                                    <div class="chart-wrapper-province">
                                        <app-chart-js chartType="bar" [chartData]="baseService.provinceChartData" [chartOptions]="baseService.provinceChartOptions" height="300px"></app-chart-js>
                                    </div>
                                </div>
                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.provinceIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="(baseService.incomeData).length > 0">
                                        <mat-card-title class="custom-card-title">
                                            {{ 'Income Breakdown by Learners' }}
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="(baseService.incomeData).length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Data"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="(baseService.incomeData).length > 0">
                                        <div *ngFor="let item of (baseService.incomeData); let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ item.category }}</span>
                                                <span class="fw-bold">{{ item.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="item.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('income', i)}"
                                                [attr.aria-label]="('Income level ') + item.category + ' ' + item.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ item.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="baseService.ageData.length > 0">
                                        <mat-card-title class="custom-card-title">Age Breakdown by
                                            Learners</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="baseService.ageData.length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Age Breakdown"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="baseService.ageData.length > 0">
                                        <div *ngFor="let age of baseService.ageData; let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ age.category }}</span>
                                                <span class="fw-bold">{{ age.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="age.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('age', i)}"
                                                [attr.aria-label]="'Age group ' + age.category + ' ' + age.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ age.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf=" (baseService.educationData).length > 0">
                                        <mat-card-title class="custom-card-title">
                                            {{ 'Education Level by Learners' }}
                                        </mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="(baseService.educationData).length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Data"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="(baseService.educationData).length > 0">
                                        <div *ngFor="let item of (baseService.educationData); let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ item.category }}</span>
                                                <span class="fw-bold">{{ item.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="item.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('education', i)}"
                                                [attr.aria-label]="( 'Education level ') + item.category + ' ' + item.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ item.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <mat-card class="breakdown-card h-100">
                                    <mat-card-header *ngIf="baseService.genderData.length > 0">
                                        <mat-card-title class="custom-card-title">Gender Breakdown by
                                            Learners</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content *ngIf="baseService.genderData.length === 0">
                                        <mat-spinner diameter="40" aria-label="Loading Gender Breakdown"></mat-spinner>
                                    </mat-card-content>
                                    <mat-card-content *ngIf="baseService.genderData.length > 0">
                                        <div *ngFor="let gender of baseService.genderData; let i = index"
                                            class="breakdown-item">
                                            <div class="d-flex justify-content-between">
                                                <span>{{ gender.category }}</span>
                                                <span class="fw-bold">{{ gender.percentage }}%</span>
                                            </div>
                                            <mat-progress-bar mode="determinate" [value]="gender.percentage"
                                                [ngStyle]="{'--mat-progress-bar-color': baseService.getColor('gender', i)}"
                                                [attr.aria-label]="'Gender ' + gender.category + ' ' + gender.percentage + '%'">
                                            </mat-progress-bar>
                                            <span class="learner-count text-muted">{{ gender.count | number }}
                                                learners</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="baseService.languageIndexData.length > 0">
                                <div class="card-header-stack">
                                    <div class="card-header-top-row">
                                        <div class="card-header-left">
                                            <mat-card-title class="custom-card-title card-title-with-tooltip">
                                                <span class="card-title-text">Learner Breakdown by Language</span>
                                                <button type="button" class="what-is-this"
                                                    matTooltipClass="dashboard-tooltip"
                                                    [matTooltip]="tooltips.text('learnerLanguageSelection')"
                                                    aria-label="What is this? Learner Breakdown by Language">
                                                    <mat-icon aria-hidden="true">info</mat-icon>
                                                    What is this?
                                                </button>
                                            </mat-card-title>
                                            <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                                        </div>
                                        <div class="card-header-right">
                                            <mat-form-field appearance="outline" class="header-filter under-header">
                                                <mat-label>Filter by Language</mat-label>
                                                <mat-select [(ngModel)]="baseService.selectedLanguage"
                                                    (selectionChange)="onLanguageFilterChange()"
                                                    aria-label="Filter by language" multiple>
                                                    <mat-option
                                                        *ngFor="let language of baseService.languages; let i = index"
                                                        [value]="language.fullName">
                                                        <span class="color-dot"
                                                            [style.backgroundColor]="baseService.colorPalettes['language'][i % baseService.colorPalettes['language'].length]"></span>
                                                        {{ language.fullName }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <mat-divider class="header-divider"></mat-divider>
                                </div>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.languageIndexData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Language Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.languageIndexData.length > 0">
                                <!-- No Data -->
                                <!-- Always show the canvas when we have chart data (including zero-state) -->
                                <mat-card-content *ngIf="baseService.languageChartData" class="chart-container">
                                    <div class="chart-wrapper-language">
                                        <app-chart-js chartType="bar" [chartData]="baseService.languageChartData" [chartOptions]="baseService.languageChartOptions" height="250px"></app-chart-js>
                                    </div>
                                </mat-card-content>

                                <!-- Only show "No data" when we genuinely have nothing (e.g. API error before zero-state) -->
                                <mat-card-content *ngIf="!baseService.languageChartData && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No language data available</p>
                                </mat-card-content>

                                <h3 class="statistics-heading">Detailed Statistics</h3>
                                <mat-divider></mat-divider>
                                <div class="index-list">
                                    <div *ngFor="let item of baseService.languageIndexData; let i = index"
                                        class="index-item">
                                        <span class="color-dot" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.name }}</span>
                                            <div class="point-stuff">
                                                {{ item.percentage }}% - {{ item.count | number }} learners
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-list-card h-100">
                            <mat-card-header *ngIf="baseService.capitecRoleChartData.length > 0">
                                <mat-card-title class="custom-card-title">Learner Engagement by
                                    User Role</mat-card-title>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.capitecRoleChartData.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Role "></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.capitecRoleChartData.length > 0">
                                <p class="text-muted date-label">{{ baseService.dateRange }}</p>
                                <div class="d-flex flex-wrap">
                                    <div class="chart-container" style="min-width: 150px; width: 40%;">
                                        <igx-pie-chart [dataSource]="baseService.capitecRoleChartData" #locationPieChart
                                            labelsMemberPath="category" valueMemberPath="percentage"
                                            [brushes]="baseService.capitecRoleColors" width="100%" height="250px"
                                            outlines="white" aria-label="Location pie chart">
                                        </igx-pie-chart>
                                    </div>
                                    <div class="list-container" style="min-width: 180px; width: 60%; margin-top: 50px">
                                        <ul class="metric-list">
                                            <li *ngFor="let capitecRole of baseService.capitecRoleData">
                                                <div class="d-flex align-items-center">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="capitecRole.color"></span>
                                                    <span>{{ capitecRole.category }}</span>
                                                </div>
                                                <div class="pie-items">
                                                    <span class="fw-bold">{{ capitecRole.count | number }} - {{
                                                        capitecRole.percentage }}%</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-list-card h-100">
                            <mat-card-header *ngIf="baseService.employmentChartData.length > 0">
                                <mat-card-title class="custom-card-title">Learner Breakdown by Employment
                                    Status</mat-card-title>
                            </mat-card-header>
                            <mat-card-content *ngIf="baseService.employmentChartData.length === 0">
                                <mat-spinner diameter="40"
                                    aria-label="Loading Employment Status Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="baseService.employmentChartData.length > 0">
                                <p class="text-muted date-label">{{ baseService.dateRange }}</p>
                                <div class="d-flex flex-wrap">
                                    <div class="chart-container" style="min-width: 150px; width: 40%;">
                                        <igx-pie-chart [dataSource]="baseService.employmentChartData"
                                            labelsMemberPath="category" valueMemberPath="percentage"
                                            [brushes]="baseService.employmentColors" width="100%" height="250px"
                                            outlines="white" aria-label="Employment Status pie chart">
                                        </igx-pie-chart>
                                    </div>
                                    <div class="list-container" style="min-width: 180px; width: 60%;">
                                        <ul class="metric-list">
                                            <li *ngFor="let employmentStatus of baseService.employmentData">
                                                <div class="d-flex align-items-center">
                                                    <span class="color-dot"
                                                        [style.backgroundColor]="employmentStatus.color"></span>
                                                    <span>{{ employmentStatus.category }}</span>
                                                </div>
                                                <div class="pie-items">
                                                    <span class="fw-bold">{{ employmentStatus.count | number }} - {{
                                                        employmentStatus.percentage }}%</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Learning Impact - Branch Manager">
                <ng-container *ngTemplateOutlet="mpiloLearningImpactContent; context: { $implicit: resolveMpiloLearningImpactView('branchManager') }"></ng-container>
            </mat-tab>
            <mat-tab label="Learning Impact - Call Center Agent">
                <ng-container *ngTemplateOutlet="mpiloLearningImpactContent; context: { $implicit: resolveMpiloLearningImpactView('callCenterAgent') }"></ng-container>
            </mat-tab>
            <mat-tab label="Feedback & Insight">
                <ng-container *ngTemplateOutlet="mpiloMandE; context: { $implicit: resolveMpiloLearningImpactView('branchManager'), mpiloMandEPathway: 'branchManager' }"></ng-container>
            </mat-tab>
            <ng-template #mpiloLearningImpactContent let-learningImpactView>
                <!-- Registration and Completions -->
                <div class="row">
                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title
                                    class="custom-card-title card-title-with-tooltip card-title-tooltip-right">
                                    <span class="card-title-text">Total Enrolled Users</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('totalRegisteredUsers')" matTooltipPosition="right"
                                        aria-label="What is this? Total Enrolled Users">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Enrolled Users"></mat-spinner>
                                </div>

                                <div *ngIf="!baseService.isLoading && baseService.isEnrolledUsersZeroState">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">
                                    <mat-card-subtitle class="sub-headings">User Count</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.enrolledUsersTotal | number }}</span>
                                        <div class="percentage-change" [ngClass]="baseService.enrolledUsersChangeClass"
                                            *ngIf="baseService.enrolledUsersChangePercentage">
                                            <mat-icon>{{ baseService.enrolledUsersChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="baseService.enrolledUsersTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Engagement Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">User Count</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ baseService.enrolledUsersTotal | number }}</span>
                                        <div class="percentage-change" [ngClass]="baseService.enrolledUsersChangeClass"
                                            *ngIf="baseService.enrolledUsersChangePercentage">
                                            <mat-icon>{{ baseService.enrolledUsersChangeIcon }}</mat-icon>
                                            <span>{{ baseService.enrolledUsersChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Total Users Who Began Course</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('startedLearning')"
                                        aria-label="What is this? Total Users Who Began Course">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Course Starters"></mat-spinner>
                                </div>
                                <div *ngIf="!baseService.isLoading && learningImpactView.usersBeganCourseTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">
                                    <mat-card-subtitle class="sub-headings">Total Starters</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.usersBeganCourseTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="learningImpactView.usersBeganCourseChangeClass"
                                            *ngIf="learningImpactView.usersBeganCourseChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.usersBeganCourseChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!baseService.isLoading && learningImpactView.usersBeganCourseTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Course Start Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Total Starters</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.usersBeganCourseTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="learningImpactView.usersBeganCourseChangeClass"
                                            *ngIf="learningImpactView.usersBeganCourseChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.usersBeganCourseChangeIcon }}</mat-icon>
                                            <span>{{ learningImpactView.usersBeganCourseChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Total Course Completions</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('completedLearning')"
                                        aria-label="What is this? Total Course Completions">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Course Completions"></mat-spinner>
                                </div>

                                <div *ngIf="!baseService.isLoading && learningImpactView.courseCompletionsTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">

                                    <mat-card-subtitle class="sub-headings">Completed All Courses</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.courseCompletionsTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="learningImpactView.courseCompletionsChangeClass"
                                            *ngIf="learningImpactView.courseCompletionsChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.courseCompletionsChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="learningImpactView.courseCompletionsTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Completion Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Completed All Courses</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.courseCompletionsTotal | number
                                            }}</span>

                                        <div class="percentage-change"
                                            [ngClass]="learningImpactView.courseCompletionsChangeClass"
                                            *ngIf="learningImpactView.courseCompletionsChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.courseCompletionsChangeIcon }}</mat-icon>
                                            <span>{{ learningImpactView.courseCompletionsChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-12 col-lg-3 mb-4">
                        <mat-card class="summary-card h-100 completion-rate-card">
                            <mat-card-header *ngIf="!baseService.isLoading">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Completion Rate</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('completionRate')"
                                        aria-label="What is this? Completion Rate">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="date-label">{{ baseService.dateRange }}</mat-card-subtitle>
                            </mat-card-header>

                            <mat-card-content>
                                <div *ngIf="baseService.isLoading" class="text-center p-4">
                                    <mat-spinner diameter="40" aria-label="Loading Completion Rate"></mat-spinner>
                                </div>
                                <div *ngIf="!baseService.isLoading && learningImpactView.completionRateTotal === 0">
                                    <img src="assets/images/zero_state-column.png" alt="No enrolled users"
                                        class="img-fluid" style="object-fit: contain; height: 30px;">

                                    <mat-card-subtitle class="sub-headings">Overall Completion Rate</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.completionRateTotal | number
                                            }}%</span>

                                        <div class="percentage-change" [ngClass]="learningImpactView.completionRateChangeClass"
                                            *ngIf="learningImpactView.completionRateChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.completionRateChangeIcon }}</mat-icon>
                                            <span>0 %</span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="learningImpactView.completionRateTotal > 0">
                                    <img src="assets/images/chartImage.png" alt="Rate Visual" class="img-fluid"
                                        style="object-fit: contain; height: 30px;" />
                                    <mat-card-subtitle class="sub-headings">Overall Completion Rate</mat-card-subtitle>

                                    <div class="d-flex align-items-center justify-content-between mt-auto">
                                        <span class="summary-value">{{ learningImpactView.completionRateTotal | number
                                            }}%</span>

                                        <div class="percentage-change" [ngClass]="learningImpactView.completionRateChangeClass"
                                            *ngIf="learningImpactView.completionRateChangePercentage !== ''">
                                            <mat-icon>{{ learningImpactView.completionRateChangeIcon }}</mat-icon>
                                            <span>{{ learningImpactView.completionRateChangePercentage }}%</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <!-- Pre/Post Quiz + Question by Question -->
                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header *ngIf="learningImpactView.prePostIndex.length > 0">
                                <mat-card-title class="custom-title-learning card-title-with-tooltip">
                                    <span class="card-title-text">Pre/Post Quiz Analysis</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('prePostQuizAnalysis')"
                                        aria-label="What is this? Pre/Post Quiz Analysis">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle pre-post-subtitle">Discover insights into pre
                                    & post quiz
                                    performance</mat-card-subtitle>
                            </mat-card-header>
                            <mat-divider class="header-divider"></mat-divider>
                            <mat-card-content *ngIf="learningImpactView.prePostIndex.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Pre/Post Quiz Breakdown"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="learningImpactView.prePostIndex.length > 0">
                                <mat-card-content
                                    *ngIf="!learningImpactView.prePostChart && !baseService.isLoading"
                                    class="text-center">
                                    <p class="text-gray-500">No quiz data available</p>
                                </mat-card-content>

                                <mat-card-content *ngIf="learningImpactView.prePostChart"
                                    class="chart-container">
                                    <div class="chart-wrapper-prePostQuiz">
                                        <app-chart-js
                                            chartType="bar"
                                            [chartData]="learningImpactView.prePostChart"
                                            [chartOptions]="learningImpactView.prePostOptions"
                                            height="500px">
                                        </app-chart-js>
                                    </div>
                                </mat-card-content>
                                <div class="index-item-quiz">
                                    <div *ngFor="let item of learningImpactView.prePostIndex; let i = index"
                                        class="index-item-quiz">
                                        <span class="color-dot-quiz" [style.backgroundColor]="item.color"></span>
                                        <div class="point-name">
                                            <span>{{ item.quiz }}</span>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-lg-6 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-header>
                                <mat-card-title class="custom-title-learning card-title-with-tooltip">
                                    <span class="card-title-text">Question by Question Analysis</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('questionByQuestionAnalysis')"
                                        aria-label="What is this? Question by Question Analysis">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights into pre & post quiz
                                    performance</mat-card-subtitle>
                            </mat-card-header>
                            <mat-divider class="header-divider"></mat-divider>
                            <mat-card-content
                                *ngIf="learningImpactView.currentPeriodStats.length === 0 && !baseService.isLoading"
                                class="text-center py-4">
                                <p class="text-gray-500">No quiz data available</p>
                            </mat-card-content>

                            <mat-card-content *ngIf="learningImpactView.currentPeriodStats.length > 0" class="table-container">
                                <div class="table-scroll">
                                    <table mat-table [dataSource]="learningImpactView.currentPeriodStats"
                                        class="mat-elevation-z4">

                                        <ng-container matColumnDef="quizQuestion">
                                            <th mat-header-cell *matHeaderCellDef class="font-bold"
                                                style="color: rgba(123, 128, 154, 1)">Question</th>
                                            <td mat-cell *matCellDef="let element" class="question-text">
                                                {{ element.quizQuestion }}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="pre_learning_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Pre-Quiz</th>
                                            <td mat-cell *matCellDef="let element" style="color:rgba(145, 158, 171, 1)">
                                                {{ element.pre_learning_percentage }}%</td>
                                        </ng-container>

                                        <ng-container matColumnDef="post_learning_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Post-Quiz</th>
                                            <td mat-cell *matCellDef="let element" style="color:rgba(61, 173, 255, 1)">
                                                {{ element.post_learning_percentage }}%</td>
                                        </ng-container>

                                        <ng-container matColumnDef="improvement_percentage">
                                            <th mat-header-cell *matHeaderCellDef style="color: rgba(123, 128, 154, 1)">
                                                Improvement</th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="pill" [ngClass]="{
                                            'positive': baseService.isPositive(element.improvement_percentage),
                                            'negative': baseService.isNegative(element.improvement_percentage)
                                            }">
                                                    {{ baseService.isPositive(element.improvement_percentage) ? '↑' :
                                                    (baseService.isNegative(element.improvement_percentage) ? '↓' : '')
                                                    }}
                                                    {{ baseService.isPositive(element.improvement_percentage) ?
                                                    element.improvement_percentage :
                                                    (baseService.isNegative(element.improvement_percentage) ?
                                                    (-element.improvement_percentage | number:'1.0-2') :
                                                    element.improvement_percentage) }}%
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row
                                            *matHeaderRowDef="baseService.displayedColumns; sticky: true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: baseService.displayedColumns;"></tr>
                                    </table>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <!-- Knowledge Gain + Key Insights -->
                <div class="row">
                    <div class="col-12 col-sm-6 mb-4">
                        <mat-card class="knowledge-gain-card">
                            <mat-card-header>
                                <mat-card-title class="card-title-assesment card-title-with-tooltip">
                                    <span class="card-title-text">Overall Knowledge Gain</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('overallKnowledgeGain')"
                                        aria-label="What is this? Overall Knowledge Gain">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="knowledge-gain-content">
                                <div class="gain-value">
                                    <span class="gain-number">
                                        {{ learningImpactView.avgImprovement }}%</span>
                                </div>
                                <div class="gain-label">
                                    Combined Learner improvement between pre & post quizzes
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-12 col-sm-6 mb-4">
                        <mat-card class="knowledge-gain-card">
                            <mat-card-header>
                                <mat-card-title class="card-title-assesment card-title-with-tooltip">
                                    <span class="card-title-text">Key Insights</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('keyInsights')"
                                        aria-label="What is this? Key Insights">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content class="knowledge-gain-content">
                                <span class="insight-text">
                                    Learners improved their knowledge by an average of {{
                                    learningImpactView.avgImprovement }}% between pre- and post-quizzes
                                </span>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <!-- Course and Quiz Table -->
                <div class="row">
                    <div class="col-12 mb-4">
                        <mat-card class="list-card h-100">
                            <mat-card-header *ngIf="learningImpactView.financeTable.length > 0" class="course-quiz-table">
                                <mat-card-title class="custom-card-title card-title-with-tooltip ">
                                    <span class="card-title-text">{{'Learning Content Progress Overview Mental Wellbeing'}}</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('learningContentProgressOverview')"
                                        aria-label="What is this? Learning Content Progress Overview">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Completion rates and performance
                                    metrics</mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content *ngIf="learningImpactView.financeTable.length === 0">
                                <mat-spinner diameter="40" aria-label="Loading Content Progress Data"></mat-spinner>
                            </mat-card-content>
                            <mat-card-content *ngIf="learningImpactView.financeTable.length > 0">
                                <table mat-table [dataSource]="learningImpactView.financeTable"
                                    class="completion-table">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef
                                            style="text-align: left; padding-left: 0;">COURSE NAME</th>
                                        <td mat-cell *matCellDef="let row" style="text-align: left; padding-left: 0;">{{
                                            row.name }}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="started_course_completion">
                                        <th mat-header-cell *matHeaderCellDef>LEARNERS ENROLLED</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.students_started | number }}</span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="course_completion">
                                        <th mat-header-cell *matHeaderCellDef>COURSE COMPLETIONS</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.course_completion | number }}</span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="quiz_completion">
                                        <th mat-header-cell *matHeaderCellDef>QUIZ COMPLETIONS</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <span class="completion-value">{{ row.quiz_completion | number }}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="course_shift">
                                        <th mat-header-cell *matHeaderCellDef>COURSE SHIFT</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <ng-container *ngIf="row.course_completion > 0">
                                                    <div class="percentage-change pill" [ngClass]="{
                                                        'positive': baseService.isPositive(row.course_change_percentage),
                                                        'negative': baseService.isNegative(row.course_change_percentage)
                                                    }">

                                                        {{ baseService.isPositive(row.course_change_percentage) ? '↑' :
                                                        (baseService.isNegative(row.course_change_percentage) ? '↓' :
                                                        '') }}

                                                        {{ baseService.isPositive(row.course_change_percentage) ?
                                                        row.course_change_percentage :
                                                        (baseService.isNegative(row.course_change_percentage) ?
                                                        (-row.course_change_percentage | number:'1.0-2') :
                                                        row.course_change_percentage) }}%
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="row.course_completion === 0">
                                                    <span class="no-data-note"
                                                        style="color: rgba(211, 214, 223, 1); font-size: 12px;">No
                                                        data</span>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="quiz_shift">
                                        <th mat-header-cell *matHeaderCellDef>QUIZ SHIFT</th>
                                        <td mat-cell *matCellDef="let row">
                                            <div class="completion-cell">
                                                <ng-container *ngIf="row.quiz_completion > 0">
                                                    <div class="percentage-change pill" [ngClass]="{
                                                        'positive': baseService.isPositive(row.quiz_change_percentage),
                                                        'negative': baseService.isNegative(row.quiz_change_percentage)
                                                    }">

                                                        {{ baseService.isPositive(row.quiz_change_percentage) ? '↑' :
                                                        (baseService.isNegative(row.quiz_change_percentage) ? '↓' : '')
                                                        }}

                                                        {{ baseService.isPositive(row.quiz_change_percentage) ?
                                                        row.quiz_change_percentage :
                                                        (baseService.isNegative(row.quiz_change_percentage) ?
                                                        (-row.quiz_change_percentage | number:'1.0-2') :
                                                        row.quiz_change_percentage) }}%
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="row.quiz_completion === 0">
                                                    <span class="no-data-note"
                                                        style="color: rgba(211, 214, 223, 1); font-size: 12px;">No
                                                        data</span>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row
                                        *matHeaderRowDef="['name', 'started_course_completion','course_completion', 'quiz_completion', 'course_shift', 'quiz_shift']">
                                    </tr>
                                    <tr mat-row
                                        *matRowDef="let row; columns: ['name', 'started_course_completion','course_completion', 'quiz_completion','course_shift', 'quiz_shift']">
                                    </tr>
                                </table>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
                <!-- Assessment Performance Overview -->
                <div class="row">
                    <div class="col-12 mb-4">
                        <mat-card class="chart-card-assesment">
                            <mat-card-content>
                                <mat-card-title class="custom-card-title">
                                    <span class="card-title-text">Assessment Performance Overview</span>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Key metrics and trends for your learning
                                    programs</mat-card-subtitle>
                                <div class="row g-3">
                                    <div class="col-12 col-sm-6 col-xl-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Pre-Test</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('preTestAssessmentOverview')" aria-label="What is this? Pre-Test">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="learningImpactView.preQuizChart">
                                                        <div class="chart-wrapper-preQuiz">
                                                            <app-chart-js
                                                                chartType="doughnut"
                                                                [chartData]="learningImpactView.preQuizChart"
                                                                [chartOptions]="baseService.doughnutChartOptions"
                                                                [chartPlugins]="[baseService.centerTextPlugin]"
                                                                height="200px">
                                                            </app-chart-js>
                                                        </div>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Post-Test</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('postTestAssessmentOverview')" aria-label="What is this? Post-Test">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="learningImpactView.postQuizChart">
                                                        <div class="chart-wrapper-postQuiz">
                                                            <app-chart-js
                                                                chartType="doughnut"
                                                                [chartData]="learningImpactView.postQuizChart"
                                                                [chartOptions]="baseService.doughnutChartOptions"
                                                                [chartPlugins]="[baseService.centerTextPlugin]"
                                                                height="200px">
                                                            </app-chart-js>
                                                        </div>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Overall Engagement Rate</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('overallEngagementRate')" aria-label="What is this? Overall Engagement Rate">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="learningImpactView.engagementChart" class="chart-wrapper-engagement">
                                                        <app-chart-js
                                                            chartType="doughnut"
                                                            [chartData]="learningImpactView.engagementChart"
                                                            [chartOptions]="baseService.doughnutChartOptions"
                                                            [chartPlugins]="[baseService.centerTextPlugin]"
                                                            height="200px">
                                                        </app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-12 col-sm-6 col-xl-3">
                                        <mat-card class="chart-card-performance">
                                            <mat-card-content class="assessment-pie-card-content">
                                                <div class="assessment-pie-chart-stack">
                                                    <mat-card-title class="assessment-pie-card-title">
                                                        <div class="card-title-assesment card-title-with-tooltip">
                                                            <span class="card-title-text">Drop-off Rate</span>
                                                            <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('dropOffRate')" aria-label="What is this? Drop-off Rate">
                                                                <mat-icon aria-hidden="true">info</mat-icon>
                                                                What is this?
                                                            </button>
                                                        </div>
                                                    </mat-card-title>
                                                    <div *ngIf="learningImpactView.dropOffChart" class="chart-wrapper-dropOff">
                                                        <app-chart-js
                                                            chartType="doughnut"
                                                            [chartData]="learningImpactView.dropOffChart"
                                                            [chartOptions]="baseService.doughnutChartOptions"
                                                            [chartPlugins]="[baseService.centerTextPlugin]"
                                                            height="200px">
                                                        </app-chart-js>
                                                    </div>
                                                </div>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </ng-template>
            <ng-template #mpiloMandE let-feedbackView let-mandEPathway="mpiloMandEPathway">
                <!--Student feedback-->
                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="main-summary-card">
                            <mat-card-content class="p-3">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Learner Feedback Summary</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('averageRating')" aria-label="What is this? Learner Feedback Summary">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights and trends from learner
                                    responses.</mat-card-subtitle>
                                <div *ngIf="baseService.isLoading" class="text-center py-5">
                                    <mat-spinner diameter="50"></mat-spinner>
                                    <p>Loading feedback summary...</p>
                                </div>
                                <div class="row summary-grid">
                                    <div class="col" *ngFor="let item of feedbackView.mAndEResponses">
                                        <mat-card class="summary-item-card">
                                            <mat-card-content class="text-center">
                                                <div class="summary-image-title">
                                                    <img src="assets/images/{{ item.image }}" alt="Engagement Visual"
                                                        class="img-fluid"
                                                        style="object-fit: contain; height: 30px; background-color: rgba(226, 247, 255, 1);" />
                                                    <span class="learning-summary-card">{{ item.title }}</span>
                                                </div>
                                                <div *ngIf="item.comment" class="comments">{{ item.comment }}</div>
                                                <h2 class="percentage">{{ item.percentage || 0 }}%</h2>
                                                <p class="description">{{ item.description }}</p>
                                                <button *ngIf="item.tooltipKey" type="button" class="what-is-this what-is-this-inline" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text(item.tooltipKey)" aria-label="What is this?">
                                                    <mat-icon aria-hidden="true">info</mat-icon>
                                                    What is this?
                                                </button>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-12 mb-4" *ngIf="feedbackView.mAndEConfig.length >= 4">
                        <mat-card class="main-summary-card">
                            <mat-card-content class="p-3">
                                <mat-card-title class="custom-card-title">
                                    M & E Feedback Survey
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">
                                    Discover insights and trends from learner responses
                                </mat-card-subtitle>
                                <div class="row mb-4">
                                    <div class="col-6 col-md-3" *ngFor="let item of feedbackView.mAndEConfig">
                                        <mat-card class="h-100 summary-item-card border-0 shadow-sm">
                                            <mat-card-content class="text-center p-4">
                                                <div class="summary-image-heading">
                                                    <img [src]="'assets/images/' + item.image + '.png'" alt="{{ item.title }}"
                                                        class="img-fluid"
                                                        style="object-fit: contain; height: 50px; background-color: rgba(226, 247, 255, 1); border-radius: 12px; padding: 8px;" />
                                                    <h3 class="title fw-bold text-dark mb-0">{{ item.title }}</h3>
                                                </div>
                                                <div *ngIf="item.comment" class="comments">{{ item.comment }}</div>
                                                <h2 class="value display-5 fw-bold mb-2" style="margin-top: 20px;"
                                                    [style.color]="item.color || '#1976d2'">
                                                    {{ item.numberMatch }}
                                                </h2>
                                                <p class="description text-muted small">{{ item.description }}</p>
                                                <button *ngIf="item.tooltipKey" type="button" class="what-is-this what-is-this-inline" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text(item.tooltipKey)" aria-label="What is this?">
                                                    <mat-icon aria-hidden="true">info</mat-icon>
                                                    What is this?
                                                </button>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-content>
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Feedback Rating Over Time</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip" [matTooltip]="tooltips.text('feedbackRatingOverTime')" aria-label="What is this? Feedback Rating Over Time">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Track the average learner ratings over
                                    time.</mat-card-subtitle>
                                <mat-divider
                                    style="color: rgba(239, 239, 239, 1) !important; margin-top: 2px; margin-bottom: 5px "></mat-divider>
                                <div *ngIf="baseService.isLoading" class="text-center py-5">
                                    <mat-spinner diameter="50"></mat-spinner>
                                </div>
                                <div *ngIf="feedbackView.mAndEChart && feedbackView.mAndEChart.labels?.length">
                                    <div class="chart-wrapper-mAndE">
                                        <app-chart-js
                                            chartType="bar"
                                            [chartData]="feedbackView.mAndEChart"
                                            [chartOptions]="baseService.mAndEChartOptions"
                                            height="408px">
                                        </app-chart-js>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Mood Tracker Summary -->
                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="mood-summary-card">
                            <mat-card-content class="p-3">
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Mood Tracker Summary</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('averageRating')"
                                        aria-label="What is this? Mood Tracker Summary">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Discover insights and trends from learner
                                    responses</mat-card-subtitle>

                                <div class="row mood-summary-grid g-3">
                                    <div class="col-12 col-md-4">
                                        <mat-card class="mood-stat-card h-100">
                                            <mat-card-content>
                                                <h4 class="mood-stat-title">Total Mood Loggers</h4>
                                                <h2 class="mood-stat-value mood-stat-value--pink">
                                                    {{ feedbackView.moodDistinctCount | number }}
                                                </h2>
                                                <p class="mood-stat-description">All-time unique users</p>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-card class="mood-stat-card h-100">
                                            <mat-card-content>
                                                <h4 class="mood-stat-title">Total Mood Entries</h4>
                                                <h2 class="mood-stat-value mood-stat-value--pink">
                                                    {{ feedbackView.moodTotalNumber | number }}
                                                </h2>
                                                <p class="mood-stat-description">All logged moods</p>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <mat-card class="mood-stat-card h-100">
                                            <mat-card-content>
                                                <h4 class="mood-stat-title">Growth Rate</h4>
                                                <h2 class="mood-stat-value mood-stat-value--green">&nbsp;</h2>
                                                <p class="mood-stat-description">Month over month</p>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Monthly Mood Logging Activity -->
                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="chart-card h-100">
                            <mat-card-content>
                                <mat-card-title class="custom-card-title card-title-with-tooltip">
                                    <span class="card-title-text">Monthly Mood Logging Activity</span>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('averageRating')"
                                        aria-label="What is this? Monthly Mood Logging Activity">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </mat-card-title>
                                <mat-card-subtitle class="custom-subtitle">Users who logged their mood each
                                    month</mat-card-subtitle>
                                <mat-divider
                                    style="color: rgba(239, 239, 239, 1) !important; margin-top: 2px; margin-bottom: 5px "></mat-divider>
                                <div *ngIf="baseService.isLoading && !feedbackView.monthlyMoodActivityChart" class="text-center py-5">
                                    <mat-spinner diameter="50"></mat-spinner>
                                </div>
                                <div *ngIf="feedbackView.monthlyMoodActivityChart && feedbackView.monthlyMoodActivityChart.labels?.length">
                                    <div class="chart-wrapper-mAndE">
                                        <app-chart-js
                                            chartType="bar"
                                            [chartData]="feedbackView.monthlyMoodActivityChart"
                                            [chartOptions]="baseService.monthlyMoodActivityChartOptions"
                                            height="408px">
                                        </app-chart-js>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Mood Breakdown & Distribution -->
                <div class="row">
                    <div class="col-12 col-lg-12 mb-4">
                        <mat-card class="mood-breakdown-card">
                            <mat-card-content class="p-3">
                                <div class="mood-breakdown-header">
                                    <div class="mood-breakdown-titles">
                                        <mat-card-title class="custom-card-title">
                                            Mood Breakdown &amp; Distribution
                                        </mat-card-title>
                                        <mat-card-subtitle class="custom-subtitle">Individual mood logging</mat-card-subtitle>
                                    </div>
                                    <button type="button" class="what-is-this" matTooltipClass="dashboard-tooltip"
                                        [matTooltip]="tooltips.text('averageRating')"
                                        aria-label="What is this? Mood Breakdown & Distribution">
                                        <mat-icon aria-hidden="true">info</mat-icon>
                                        What is this?
                                    </button>
                                </div>
                                <mat-divider class="mood-breakdown-divider"></mat-divider>

                                <div *ngIf="baseService.isLoading && !feedbackView.moodAnalytics?.length"
                                    class="text-center py-4">
                                    <mat-spinner diameter="40" aria-label="Loading Mood Breakdown"></mat-spinner>
                                </div>

                                <div *ngIf="!baseService.isLoading && feedbackView.moodAnalytics?.length === 0"
                                    class="text-center py-4">
                                    <p class="text-gray-500">No mood data available</p>
                                </div>

                                <div *ngIf="feedbackView.moodAnalytics?.length" class="mood-breakdown-list">
                                    <div *ngFor="let mood of feedbackView.moodAnalytics"
                                        class="mood-breakdown-item"
                                        [ngClass]="'mood-breakdown-item--' + (mood.selected_emotion | lowercase)">
                                        <div class="mood-breakdown-item__header">
                                            <span class="mood-breakdown-item__label">{{ mood.selected_emotion }}</span>
                                            <span class="mood-breakdown-item__count">{{ mood.count | number }} Learners</span>
                                        </div>
                                        <mat-progress-bar mode="determinate"
                                            [value]="mood.percentage"
                                            [ngStyle]="{
                                                '--mood-bar-color': baseService.moodBarColorFor(mood.selected_emotion),
                                                '--mat-progress-bar-color': baseService.moodBarColorFor(mood.selected_emotion),
                                                '--mdc-linear-progress-active-indicator-color': baseService.moodBarColorFor(mood.selected_emotion)
                                            }"
                                            [attr.aria-label]="'Emotion ' + mood.selected_emotion + ' ' + mood.percentage + '%'">
                                        </mat-progress-bar>
                                        <div class="mood-breakdown-item__footer">
                                            <span class="mood-breakdown-item__percentage">{{ mood.percentage }}%</span>
                                        </div>
                                    </div>
                                </div>

                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </ng-template>
        </mat-tab-group>
    </div>
</div>
